// extracted by mini-css-extract-plugin
module.exports = {"menu":"SelectParentSessionInput_menu__25-Af","icon":"SelectParentSessionInput_icon__3FI6a"};